import React, { useState, useMemo } from "react";
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from "react-i18next";
import Lottie from 'react-lottie-player/dist/LottiePlayerLight'

import {
  Modal,
  Button
} from '@lockerpm/design';

import {
} from "@ant-design/icons";

import global from "../../../../../config/global";
import projectServices from "../../../../../services/project";
import storeActions from "../../../../../store/actions";
import { validateUrl } from "../../../../../utils/validate";

const SetupKeyModal = (props) => {
  const { t } = useTranslation()
  const {
    visible = false,
    onClose = () => {},
  } = props;

  const locale = useSelector((state) => state.system.locale);
  const selectedProject = useSelector((state) => state.project.selectedProject);

  const [callingAPI, setCallingAPI] = useState(false);

  const handleUpdateOnboarding = async () => {
    if (selectedProject?.access_key_onboarding || selectedProject?.role === global.constants.PROJECT_MEMBER_ROLE.READ_ONLY) {
      onClose();
      return; 
    }
    setCallingAPI(true);
    await projectServices.update(selectedProject.id, { access_key_onboarding: true }).then(async () => {
      global.store.dispatch(storeActions.updateIsFetchProjects(true));
      setTimeout(() => {
        onClose()
      }, 500);
    }).catch((error) => {
      onClose()
    })
    setCallingAPI(false);
  }

  const programmingLanguage = useMemo(() => {
    const data = { doc_url: '' }
    if (selectedProject?.programming_language === 'python') {
      data.doc_url = global.urls.DOC_LINKS[locale].PYTHON_USAGES
    } else if (selectedProject?.programming_language === 'csharp') {
      data.doc_url = global.urls.DOC_LINKS[locale].NET_USAGES
    } else if (selectedProject?.programming_language === 'java') {
      data.doc_url = global.urls.DOC_LINKS[locale].JAVA_USAGES
    } else if (selectedProject?.programming_language === 'javascript') {
      data.doc_url = global.urls.DOC_LINKS[locale].NODE_USAGES
    } else {
      data.doc_url = global.urls.DOC_LINKS[locale].CLI_USAGES
    }
    return data
  }, [selectedProject, locale])

  return (
    <Modal
      title={<p className="text-2xl font-semibold">{t('onboarding.access_key_modal.title')}</p>}
      open={visible}
      width={500}
      onCancel={() => {}}
      closable={false}
      footer={<div className="flex items-center justify-end">
        <Button
          type="primary"
          loading={callingAPI}
          onClick={() => handleUpdateOnboarding()}
        >
          {t('onboarding.access_key_modal.btn')}
        </Button>
      </div>}
    >
      <div>
        <p className="mb-6">
          {(() => {
            const docUrl = validateUrl(programmingLanguage?.doc_url, false);
            return (
              <Trans
                i18nKey={'onboarding.access_key_modal.description_1'}
                components={{
                  a: <a
                    className="underline"
                    href={docUrl || undefined}
                    target={docUrl ? "_blank" : undefined}
                    rel={docUrl ? "noopener noreferrer" : undefined}
                    onClick={(e) => {
                      if (!docUrl) e.preventDefault();
                    }}
                  />
                }}
              />
            );
          })()}
        </p>
        <p className="mb-4">
          {t('onboarding.access_key_modal.description_2')}
        </p>
        <div className="w-full">
          <Lottie
            rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
            loop
            play
            path="/motions/setup.json"
          />
        </div>
      </div>
    </Modal>
  );
}

export default SetupKeyModal;